import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';
import { useI18n } from 'locales';

const criteria = [
  { label: 'At least 8 characters', test: (v) => v.length >= 8 },
  { label: 'At least 1 uppercase letter', test: (v) => /[A-Z]/.test(v) },
  { label: 'At least 1 lowercase letter', test: (v) => /[a-z]/.test(v) },
  { label: 'At least 1 number or special character', test: (v) => /[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(v) },
];

export const passwordStrengthCriteria = criteria.map(({ test }) => test);

function PasswordStrengthChecklist({ value = '' }) {
  const t = useI18n();

  return (
    <Stack gap={0.25} sx={{ mt: 0.5 }}>
      {criteria.map(({ label, test }) => {
        const met = value.length > 0 && test(value);
        return (
          <Stack key={label} direction="row" gap={0.75} alignItems="center">
            <FontAwesomeIcon
              icon={met ? faCheck : faXmark}
              style={{ color: met ? '#2e7d32' : '#9e9e9e', fontSize: '0.7rem', width: '10px' }}
            />
            <Typography variant="body2" sx={{ color: met ? 'success.dark' : 'text.secondary' }}>
              {t(label)}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
}

export default PasswordStrengthChecklist;
